<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MarkVision Enterprise">
     MarkVision Enterprise
    </a>
   </p>
   <p class="toc-1-style">
    <a href="change-history.html#change-history_fr" title="Historique des modifications">
     Historique des modifications
    </a>
   </p>
   <div id="divd0e8">
   </div>
   <p class="toc-1-style">
    <a href="overview-chapter.html#overview-chapter_fr" title="Aper&ccedil;u">
     Aper&ccedil;u
    </a>
   </p>
   <div id="divd0e260">
    <p class="toc-2-style">
     <a href="overview-chapter.html#overview-markvision-enterprise_fr" title="Comprendre Markvision Enterprise">
      Comprendre Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="getting-started-chapter.html#getting-started-chapter_fr" title="Mise en route">
     Mise en route
    </a>
   </p>
   <div id="divd0e289">
    <p class="toc-2-style">
     <a href="best-practices-topic.html#best-practices_fr" title="Meilleures pratiques">
      Meilleures pratiques
     </a>
    </p>
    <p class="toc-2-style">
     <a href="system-requirements-topic.html#system-requirements_fr" title="Configuration requise">
      Configuration requise
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-languages-topic.html#supported-languages_fr" title="Langues prises en charge">
      Langues prises en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-printer-models-topic.html#supported-printer-models_fr" title="Mod&egrave;les d'imprimante pris en charge">
      Mod&egrave;les d'imprimante pris en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-database-topic.html#setting-up-database_fr" title="Configuration de la base de donn&eacute;es">
      Configuration de la base de donn&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-mve-run-as-user-topic.html#d0e1132" title="Configuration d'une ex&eacute;cution en tant qu'utilisateur">
      Configuration d'une ex&eacute;cution en tant qu'utilisateur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-markvision-topic.html#installing-markvision_fr" title="Installation de MVE">
      Installation de MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-mve-silently-topic.html#installing-mve-silently_fr" title="Installation silencieuse de MVE">
      Installation silencieuse de MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-topic.html#accessing-mve_fr" title="Acc&egrave;s &agrave; MVE">
      Acc&egrave;s &agrave; MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-topic.html#changing-language_fr" title="Modification de la langue">
      Modification de la langue
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-your-password-topic.html#changing-your-password_fr" title="Modification de votre mot de passe">
      Modification de votre mot de passe
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-application-chapter.html#maintaining-application-chapter_fr" title="Maintenance de l'application">
     Maintenance de l'application
    </a>
   </p>
   <div id="divd0e1715">
    <p class="toc-2-style">
     <a href="upgrading-to-latest-version-topic.html#upgrading-to-latest-version_fr" title="Mise &agrave; niveau vers MVE&nbsp;4.3">
      Mise &agrave; niveau vers MVE&nbsp;4.3
     </a>
    </p>
    <p class="toc-2-style">
     <a href="backing-up-and-restoring-database-topic.html#backing-up-and-restoring-database_fr" title="Sauvegarde et restauration de la base de donn&eacute;es">
      Sauvegarde et restauration de la base de donn&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-installer-settings-topic.html#changing-installer-settings_fr" title="Mise &agrave; jour des param&egrave;tres du programme d'installation apr&egrave;s l'installation">
      Mise &agrave; jour des param&egrave;tres du programme d'installation apr&egrave;s l'installation
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-user-access-chapter.html#setting-user-access-chapter_fr" title="Configuration de l'acc&egrave;s utilisateur">
     Configuration de l'acc&egrave;s utilisateur
    </a>
   </p>
   <div id="divd0e1987">
    <p class="toc-2-style">
     <a href="setting-up-user-access-overview-topic.html#setting-up-user-access-overview_fr" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-user-roles-topic.html#understanding-user-roles_fr" title="Pr&eacute;sentation des r&ocirc;les utilisateur">
      Pr&eacute;sentation des r&ocirc;les utilisateur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-users-topic.html#managing-users_fr" title="Gestion des utilisateurs">
      Gestion des utilisateurs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-ldap-server-authentication-topic.html#enabling-ldap-server-authentication_fr" title="Activation de l'authentification de serveur&nbsp;LDAP">
      Activation de l'authentification de serveur&nbsp;LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-ldap-server-certificates-topic.html#installing-ldap-server-certificates_fr" title="Installation de certificats de serveur LDAP">
      Installation de certificats de serveur LDAP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-root-ca-certificate-java-truststore-topic.html#adding-root-ca-certificate-java-truststore_fr" title="Ajout d'un certificat CA racine dans le magasin d'approbation Java">
      Ajout d'un certificat CA racine dans le magasin d'approbation Java
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="discovering-devices-chapter.html#discovering-devices-chapter_fr" title="D&eacute;tection des imprimantes">
     D&eacute;tection des imprimantes
    </a>
   </p>
   <div id="divd0e2401">
    <p class="toc-2-style">
     <a href="creating-discovery-profile-topic.html#creating-discovery-profile_fr" title="Cr&eacute;ation d'un profil de recherche">
      Cr&eacute;ation d'un profil de recherche
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-discovery-profiles-topic.html#managing-discovery-profiles_fr" title="Gestion des profils de recherche">
      Gestion des profils de recherche
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-discovering-printers-topic.html#sample-scenario-discovering-printers_fr" title="Exemple de sc&eacute;nario&nbsp;: D&eacute;tection des imprimantes">
      Exemple de sc&eacute;nario&nbsp;: D&eacute;tection des imprimantes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintaining-dashboard-chapter.html#maintaining-dashboard-chapter_fr" title="Gestion du tableau de bord de s&eacute;curit&eacute;">
     Gestion du tableau de bord de s&eacute;curit&eacute;
    </a>
   </p>
   <div id="divd0e2657">
    <p class="toc-2-style">
     <a href="overview-security-dashboard-topic.html#overview-security-dashboard_fr" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-dashboard-topic.html#accessing-dashboard_fr" title="Acc&egrave;s au tableau de bord de s&eacute;curit&eacute;">
      Acc&egrave;s au tableau de bord de s&eacute;curit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-security-information-topic.html#managing-device-security-information_fr" title="Gestion de la page Informations de s&eacute;curit&eacute; du p&eacute;riph&eacute;rique">
      Gestion de la page Informations de s&eacute;curit&eacute; du p&eacute;riph&eacute;rique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-device-conformance-check-topic.html#managing-device-conformance-check_fr" title="Gestion de la page Contr&ocirc;le de conformit&eacute; d'un p&eacute;riph&eacute;rique">
      Gestion de la page Contr&ocirc;le de conformit&eacute; d'un p&eacute;riph&eacute;rique
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="finding-devices-chapter.html#finding-devices-chapter_fr" title="Affichage des imprimantes">
     Affichage des imprimantes
    </a>
   </p>
   <div id="divd0e2766">
    <p class="toc-2-style">
     <a href="viewing-printer-list-topic.html#viewing-printer-list_fr" title="Affichage de la liste des imprimantes">
      Affichage de la liste des imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-device-information-topic.html#viewing-device-information_fr" title="Affichage des informations de l'imprimante">
      Affichage des informations de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-data-topic.html#exporting-data_fr" title="Exportation des donn&eacute;es de l'imprimante">
      Exportation des donn&eacute;es de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-views-topic.html#managing-views_fr" title="Gestion des vues">
      Gestion des vues
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-printer-listing-view-topic.html#changing-printer-listing-view_fr" title="Modification de la vue Liste des imprimantes">
      Modification de la vue Liste des imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="filtering-printers-using-search-bar-topic.html#filtering-printers-using-search-bar_fr" title="Filtrage des imprimantes via la barre de recherche">
      Filtrage des imprimantes via la barre de recherche
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-keywords-topic.html#managing-keywords_fr" title="Gestion des mots cl&eacute;s">
      Gestion des mots cl&eacute;s
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-device-life-cycle-states-topic.html#d0e3226" title="Utilisation des recherches enregistr&eacute;es">
      Utilisation des recherches enregistr&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-monitor-fleet-topic.html#sample-scenario-monitor-fleet_fr" title="Exemple de sc&eacute;nario&nbsp;: Surveillance des niveaux de toner de votre parc">
      Exemple de sc&eacute;nario&nbsp;: Surveillance des niveaux de toner de votre parc
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-devices-chapter.html#securing-devices-chapter_fr" title="S&eacute;curisation des communications avec l'imprimante">
     S&eacute;curisation des communications avec l'imprimante
    </a>
   </p>
   <div id="divd0e4163">
    <p class="toc-2-style">
     <a href="understanding-security-status-topic.html#understanding-security-status_fr" title="Pr&eacute;sentation des &eacute;tats de s&eacute;curit&eacute; de l'imprimante">
      Pr&eacute;sentation des &eacute;tats de s&eacute;curit&eacute; de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-using-default-config-topic.html#securing-printers-using-default-config_fr" title="S&eacute;curisation des imprimantes &agrave; l'aide des configurations par d&eacute;faut">
      S&eacute;curisation des imprimantes &agrave; l'aide des configurations par d&eacute;faut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-fac-permissions-topic.html#understanding-fac-permissions_fr" title="Pr&eacute;sentation des autorisations et des contr&ocirc;les d'acc&egrave;s aux fonctions">
      Pr&eacute;sentation des autorisations et des contr&ocirc;les d'acc&egrave;s aux fonctions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-device-security-topic.html#configuring-device-security_fr" title="Configuration de la s&eacute;curit&eacute; d'une imprimante">
      Configuration de la s&eacute;curit&eacute; d'une imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printer-communications-on-your-fleet-topic.html#securing-printer-communications-on-your-fleet_fr" title="S&eacute;curisation des communications avec les imprimantes de votre parc">
      S&eacute;curisation des communications avec les imprimantes de votre parc
     </a>
    </p>
    <p class="toc-2-style">
     <a href="securing-printers-topic.html#securing-printers_fr" title="Autres m&eacute;thodes de s&eacute;curisation de vos imprimantes">
      Autres m&eacute;thodes de s&eacute;curisation de vos imprimantes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-assets-chapter.html#managing-assets-chapter_fr" title="Gestion des imprimantes">
     Gestion des imprimantes
    </a>
   </p>
   <div id="divd0e4527">
    <p class="toc-2-style">
     <a href="restarting-printer-topic.html#restarting-printer_fr" title="Red&eacute;marrage de l'imprimante">
      Red&eacute;marrage de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-ews-topic.html#viewing-ews_fr" title="Affichage de l'Embedded Web Server de l'imprimante">
      Affichage de l'Embedded Web Server de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="auditing-devices-topic.html#auditing-devices_fr" title="Audit d'imprimantes">
      Audit d'imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-status-topic.html#updating-printer-status_fr" title="Mise &agrave; jour de l'&eacute;tat de l'imprimante">
      Mise &agrave; jour de l'&eacute;tat de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-device-state-topic.html#setting-device-state_fr" title="R&eacute;glage de l'&eacute;tat de l'imprimante">
      R&eacute;glage de l'&eacute;tat de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-configurations-to-devices-topic.html#assigning-configurations-to-devices_fr" title="Attribution de configurations &agrave; des imprimantes">
      Attribution de configurations &agrave; des imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unassigning-configurations-topic.html#unassigning-configurations_fr" title="Annulation de l'attribution de configurations">
      Annulation de l'attribution de configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enforcing-configurations-topic.html#enforcing-configurations_fr" title="Mise en &oelig;uvre de configurations">
      Mise en &oelig;uvre de configurations
     </a>
    </p>
    <p class="toc-2-style">
     <a href="checking-device-conformance-topic.html#checking-device-conformance_fr" title="V&eacute;rification de la conformit&eacute; d'une imprimante avec une configuration">
      V&eacute;rification de la conformit&eacute; d'une imprimante avec une configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="deploying-files-to-printers-topic.html#deploying-files-to-printers_fr" title="D&eacute;ploiement de fichiers sur des imprimantes">
      D&eacute;ploiement de fichiers sur des imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="updating-printer-firmware-topic.html#updating-printer-firmware_fr" title="Mise &agrave; jour du microcode de l'imprimante">
      Mise &agrave; jour du microcode de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="uninstalling-applications-from-devices-topic.html#uninstalling-applications-from-devices_fr" title="D&eacute;sinstallation d'applications pr&eacute;sentes sur les imprimantes">
      D&eacute;sinstallation d'applications pr&eacute;sentes sur les imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-events-to-device-topic.html#assigning-events-to-device_fr" title="Attribution d'&eacute;v&eacute;nements &agrave; des imprimantes">
      Attribution d'&eacute;v&eacute;nements &agrave; des imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="assigning-keyword-topic.html#assigning-keyword_fr" title="Attribution de mots-cl&eacute;s aux imprimantes">
      Attribution de mots-cl&eacute;s aux imprimantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="entering-credentials-secured-printers-topic.html#entering-credentials-secured-printers_fr" title="Saisie des informations d'identification pour les imprimantes s&eacute;curis&eacute;es">
      Saisie des informations d'identification pour les imprimantes s&eacute;curis&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-certificates-manually-topic.html#configuring-printer-certificates-manually_fr" title="Configuration manuelle des certificats d'imprimante par d&eacute;faut">
      Configuration manuelle des certificats d'imprimante par d&eacute;faut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-printers-topic.html#removing-printers_fr" title="Suppression d'imprimantes">
      Suppression d'imprimantes
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-configurations-chapter.html#managing-configurations-chapter_fr" title="Gestion des configurations">
     Gestion des configurations
    </a>
   </p>
   <div id="divd0e5133">
    <p class="toc-2-style">
     <a href="managing-configurations-overview-topic.html#managing-configurations-overview_fr" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-topic.html#creating-configuration_fr" title="Cr&eacute;ation d'une configuration">
      Cr&eacute;ation d'une configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-configuration-from-printer-topic.html#creating-configuration-from-printer_fr" title="Cr&eacute;ation d'une configuration &agrave; partir d'une imprimante">
      Cr&eacute;ation d'une configuration &agrave; partir d'une imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sample-scenario-cloning-configurations-topic.html#sample-scenario-cloning-configurations_fr" title="Exemple de sc&eacute;nario&nbsp;: clonage d'une configuration">
      Exemple de sc&eacute;nario&nbsp;: clonage d'une configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-advanced-security-component-topic.html#creating-advanced-security-component_fr" title="Cr&eacute;ation d'un composant de s&eacute;curit&eacute; avanc&eacute;e &agrave; partir d'une imprimante">
      Cr&eacute;ation d'un composant de s&eacute;curit&eacute; avanc&eacute;e &agrave; partir d'une imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-printable-version-topic.html#generating-printable-version_fr" title="G&eacute;n&eacute;ration d'une version imprimable des param&egrave;tres de configuration">
      G&eacute;n&eacute;ration d'une version imprimable des param&egrave;tres de configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-dynamic-settings-topic.html#understanding-dynamic-settings_fr" title="Comprendre les param&egrave;tres dynamiques">
      Comprendre les param&egrave;tres dynamiques
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-variable-settings-topic.html#understanding-variable-settings_fr" title="Pr&eacute;sentation des param&egrave;tres de variable">
      Pr&eacute;sentation des param&egrave;tres de variable
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-color-permissions-topic.html#configuring-color-permissions_fr" title="Configuration des autorisations d'impression couleur">
      Configuration des autorisations d'impression couleur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-applications-package-topic.html#creating-applications-package_fr" title="Cr&eacute;ation d'un package d'applications">
      Cr&eacute;ation d'un package d'applications
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-exporting-configuration-file-topic.html#importing-exporting-configuration-file_fr" title="Importation ou exportation d'une configuration">
      Importation ou exportation d'une configuration
     </a>
    </p>
    <p class="toc-2-style">
     <a href="importing-files-to-resource-library-topic.html#importing-files-to-resource-library_fr" title="Importation de fichiers vers la biblioth&egrave;que de ressources">
      Importation de fichiers vers la biblioth&egrave;que de ressources
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-cert-auto-manage-chapter.html#setting-up-cert-auto-manage-chapter_fr" title="Gestion des certificats">
     Gestion des certificats
    </a>
   </p>
   <div id="divd0e5644">
    <p class="toc-2-style">
     <a href="setting-up-MVE-manage-certificates-automatically-group.html#d0e5647" title="Configuration de MVE pour g&eacute;rer automatiquement les certificats">
      Configuration de MVE pour g&eacute;rer automatiquement les certificats
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-SCEP-group.html#d0e5973" title="Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via SCEP">
      Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-MSCEWS-group.html#d0e6695" title="Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via MSCEWS">
      Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification Microsoft via MSCEWS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-OpenXPKI-CA-group.html#d0e7680" title="Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via SCEP">
      Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via SCEP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-certificates-using-EST-group.html#d0e8747" title="Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via EST">
      Gestion des certificats &agrave; l'aide de l'autorit&eacute; de certification OpenXPKI via EST
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-device-alerts-chapter.html#managing-device-alerts-chapter_fr" title="Gestion des alertes d'imprimante">
     Gestion des alertes d'imprimante
    </a>
   </p>
   <div id="divd0e9832">
    <p class="toc-2-style">
     <a href="managing-printer-alerts-overview-topic.html#managing-printer-alerts-overview_fr" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-action-topic.html#creating-action_fr" title="Cr&eacute;ation d'une action">
      Cr&eacute;ation d'une action
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-action-placeholders-topic.html#understanding-action-placeholders_fr" title="Compr&eacute;hension des espaces r&eacute;serv&eacute;s d'action">
      Compr&eacute;hension des espaces r&eacute;serv&eacute;s d'action
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-actions-topic.html#managing-actions_fr" title="Gestion des actions">
      Gestion des actions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-event-topic.html#creating-event_fr" title="Cr&eacute;ation d'un &eacute;v&eacute;nement">
      Cr&eacute;ation d'un &eacute;v&eacute;nement
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-printer-alerts-topic.html#understanding-printer-alerts_fr" title="Pr&eacute;sentation des alertes d'imprimante">
      Pr&eacute;sentation des alertes d'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-events-topic.html#managing-events_fr" title="Gestion des &eacute;v&eacute;nements">
      Gestion des &eacute;v&eacute;nements
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="viewing-tasks-chapter.html#viewing-tasks-chapter_fr" title="Affichage de l'&eacute;tat et de l'historique d'une t&acirc;che">
     Affichage de l'&eacute;tat et de l'historique d'une t&acirc;che
    </a>
   </p>
   <div id="divd0e10464">
    <p class="toc-2-style">
     <a href="viewing-task-status-history-overview-topic.html#viewing-task-status-history-overview_fr" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-task-status-topic.html#viewing-task-status_fr" title="Affichage de l'&eacute;tat de la t&acirc;che">
      Affichage de l'&eacute;tat de la t&acirc;che
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stopping-tasks-topic.html#stopping-tasks_fr" title="Arr&ecirc;t des t&acirc;ches">
      Arr&ecirc;t des t&acirc;ches
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-logs-topic.html#viewing-logs_fr" title="Affichage des journaux">
      Affichage des journaux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-logs-topic.html#clearing-logs_fr" title="Effacement des journaux">
      Effacement des journaux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-logs-topic.html#exporting-logs_fr" title="Exporter les journaux">
      Exporter les journaux
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="scheduling-tasks.html#scheduling-tasks_fr" title="Planification de t&acirc;ches">
     Planification de t&acirc;ches
    </a>
   </p>
   <div id="divd0e10572">
    <p class="toc-2-style">
     <a href="creating-schedule-topic.html#creating-schedule_fr" title="Cr&eacute;ation d'une programmation">
      Cr&eacute;ation d'une programmation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="managing-schedules-topic.html#managing-schedules_fr" title="Gestion des t&acirc;ches planifi&eacute;es">
      Gestion des t&acirc;ches planifi&eacute;es
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="admin-tasks-chapter.html#admin-tasks-chapter_fr" title="Autres t&acirc;ches administratives">
     Autres t&acirc;ches administratives
    </a>
   </p>
   <div id="divd0e10714">
    <p class="toc-2-style">
     <a href="configuring-system-settings-topic.html#configuring-system-settings_fr" title="Configuration des param&egrave;tres g&eacute;n&eacute;raux">
      Configuration des param&egrave;tres g&eacute;n&eacute;raux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-email-settings-topic.html#configuring-email-settings_fr" title="Configuration des param&egrave;tres de courrier &eacute;lectronique">
      Configuration des param&egrave;tres de courrier &eacute;lectronique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-login-disclaimer-topic.html#adding-login-disclaimer_fr" title="Ajout d'un avertissement de connexion">
      Ajout d'un avertissement de connexion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="signing-mve-certificate-topic.html#signing-mve-certificate_fr" title="Signature du certificat&nbsp;MVE">
      Signature du certificat&nbsp;MVE
     </a>
    </p>
    <p class="toc-2-style">
     <a href="removing-user-information-topic.html#removing-user-information_fr" title="Suppression des r&eacute;f&eacute;rences et des informations utilisateur">
      Suppression des r&eacute;f&eacute;rences et des informations utilisateur
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="managing-SSO-chapter.html#managing-SSO-chapter_fr" title="Gestion de la fonction SSO">
     Gestion de la fonction SSO
    </a>
   </p>
   <div id="divd0e10972">
    <p class="toc-2-style">
     <a href="mve-configuration-workflow-adfs-overview-topic.html#d0e10977" title="Aper&ccedil;u">
      Aper&ccedil;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-grouprule-topic.html#setting-claim-issuance-policy-grouprule_fr" title="D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour GroupRule">
      D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour GroupRule
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-claim-issuance-policy-name-id-topic.html#setting-claim-issuance-policy-name-id_fr" title="D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour l'ID de nom">
      D&eacute;finition de la strat&eacute;gie d'&eacute;mission de revendications pour l'ID de nom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-adfs-server-authentication-topic.html#enabling-adfs-server-authentication_fr" title="Activation de l'authentification de serveur&nbsp;ADFS">
      Activation de l'authentification de serveur&nbsp;ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="accessing-mve-adfs-topic.html#accessing-mve-adfs_fr" title="Acc&egrave;s &agrave; MVE par le biais de l'ADFS">
      Acc&egrave;s &agrave; MVE par le biais de l'ADFS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="logging-out-mve-adfs-topic.html#logging-out-mve-adfs_fr" title="D&eacute;connexion de MVE">
      D&eacute;connexion de MVE
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faq-chapter.html#faq-chapter_fr" title="Questions fr&eacute;quemment pos&eacute;es">
     Questions fr&eacute;quemment pos&eacute;es
    </a>
   </p>
   <div id="divd0e11142">
    <p class="toc-2-style">
     <a href="faq-chapter.html#frequently-asked-questions_fr" title="FAQ Markvision Enterprise">
      FAQ Markvision Enterprise
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_fr" title="D&eacute;pannage">
     D&eacute;pannage
    </a>
   </p>
   <div id="divd0e11336">
    <p class="toc-2-style">
     <a href="trb-forgotten-password-mve-topic.html#trb-forgotten-password-mve_fr" title="L'utilisateur a oubli&eacute; son mot de passe">
      L'utilisateur a oubli&eacute; son mot de passe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-admin-forgotten-password-mve-topic.html#trb-admin-forgotten-password-mve_fr" title="L'utilisateur administrateur a oubli&eacute; son mot de passe">
      L'utilisateur administrateur a oubli&eacute; son mot de passe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-page-loading-infinitely-topic.html#trb-page-loading-infinitely_fr" title="La page ne charge pas">
      La page ne charge pas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-discover-network-device-topic.html#trb-cannot-discover-network-device_fr" title="Impossible de d&eacute;tecter une imprimante r&eacute;seau">
      Impossible de d&eacute;tecter une imprimante r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-incorrect-device-information-topic.html#trb-incorrect-device-information_fr" title="Informations d'imprimante incorrectes">
      Informations d'imprimante incorrectes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-mve-does-not-recognize-secured-printer-topic.html#trb-mve-does-not-recognize-secured-printer_fr" title="MVE ne reconna&icirc;t pas une imprimante comme imprimante s&eacute;curis&eacute;e">
      MVE ne reconna&icirc;t pas une imprimante comme imprimante s&eacute;curis&eacute;e
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-config-enforcement-fails-topic.html#trb-config-enforcement-fails_fr" title="L'application de configurations avec plusieurs applications &eacute;choue &agrave; la premi&egrave;re tentative, mais r&eacute;ussit lors des tentatives suivantes">
      L'application de configurations avec plusieurs applications &eacute;choue &agrave; la premi&egrave;re tentative, mais r&eacute;ussit lors des tentatives suivantes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-enforcement-printer-cert-fails-topic.html#trb-enforcement-printer-cert-fails_fr" title="Echec de l'application des configurations avec un certificat d'imprimante">
      Echec de l'application des configurations avec un certificat d'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-openxpki-ca-group.html#d0e11553" title="Autorit&eacute; de certification OpenXPKI">
      Autorit&eacute; de certification OpenXPKI
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="database-access-chapter.html#database-access-chapter_fr" title="Acc&egrave;s aux bases de donn&eacute;es">
     Acc&egrave;s aux bases de donn&eacute;es
    </a>
   </p>
   <div id="divd0e11723">
    <p class="toc-2-style">
     <a href="differences-supported-databases-data-types-topic.html#differences-supported-databases-data-types_fr" title="Diff&eacute;rences entre les types de donn&eacute;es des bases de donn&eacute;es prises en charge">
      Diff&eacute;rences entre les types de donn&eacute;es des bases de donn&eacute;es prises en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="config-item-topic.html#d0e11784" title="Tables FRAMEWORK et noms du champ">
      Tables FRAMEWORK et noms du champ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="appendix-chapter.html#appendix-chapter_fr" title="Annexe">
     Annexe
    </a>
   </p>
   <div id="divd0e17724">
    <p class="toc-2-style">
     <a href="understanding-ports-and-protocols-topic.html#understanding-ports-and-protocols_fr" title="Pr&eacute;sentation des ports et protocoles">
      Pr&eacute;sentation des ports et protocoles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-automatic-approval-certificate-requests-microsoft-ca-topic.html#enabling-automatic-approval-certificate-requests-microsoft-ca_fr" title="Activation de l'approbation automatique des demandes de certificat dans l'autorit&eacute; de certification Microsoft">
      Activation de l'approbation automatique des demandes de certificat dans l'autorit&eacute; de certification Microsoft
     </a>
    </p>
    <p class="toc-2-style">
     <a href="revoking-certificates-topic.html#revoking-certificates_fr" title="R&eacute;vocation des certificats">
      R&eacute;vocation des certificats
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="leap_notices.html#leap_notices_fr" title="Avis">
     Avis
    </a>
   </p>
   <div id="divd0e18100">
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18103" title="Note d'&eacute;dition">
      Note d'&eacute;dition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#d0e18139" title="Marques commerciales">
      Marques commerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#us-government-rights_fr" title="GOVERNMENT END USERS">
      GOVERNMENT END USERS
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#jmdns-license_fr" title="JmDNS License">
      JmDNS License
     </a>
    </p>
    <p class="toc-2-style">
     <a href="leap_notices.html#licensing-notices-program-folder_fr" title="Avis relatifs &agrave; l'accord de licence">
      Avis relatifs &agrave; l'accord de licence
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="glossary.html#glossary_fr" title="Glossaire">
     Glossaire
    </a>
   </p>
   <div id="divd0e18169">
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue